import { Component, input } from '@angular/core';

@Component({
  selector: 'app-marker-stop',
  templateUrl: './marker-stop.component.html',
  styleUrl: './marker-stop.component.scss',
  standalone: false
})
export class MarkerStopComponent {
  readonly absolute = input<boolean>(true);
  readonly color = input.required<string>();
  readonly scale = input<number>(1);
  readonly count = input<number>();

  get styles(): any {
    return {
      'background-color': `${this.color()}`,
      'width': `${ this.scale() ? Math.floor(24 * this.scale()) : 24 }px`,
      'height': `${ this.scale() ? Math.floor(24 * this.scale()) : 24 }px`
    };
  }

  get whiteDotStyles(): any {
    return {
      'width': `${ this.scale() ? (Math.floor(24 * this.scale()) - Math.floor(12 * this.scale())) : 12 }px`,
      'height': `${ this.scale() ? (Math.floor(24 * this.scale()) - Math.floor(12 * this.scale())) : 12 }px`
    }
  }

}
